// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HRffP","footer":"styles_footer__1fXD5","passCodeTooltip":"styles_passCodeTooltip__1gwfs"};